import { ViewContainerRef, TemplateRef } from '@angular/core';
var NgTranscludeDirective = /** @class */ (function () {
    function NgTranscludeDirective(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    Object.defineProperty(NgTranscludeDirective.prototype, "ngTransclude", {
        get: function () {
            return this.transclude;
        },
        set: function (templateRef) {
            this.transclude = templateRef;
            if (templateRef) {
                this.viewContainerRef.createEmbeddedView(templateRef);
            }
        },
        enumerable: true,
        configurable: true
    });
    return NgTranscludeDirective;
}());
export { NgTranscludeDirective };



// WEBPACK FOOTER //
// ./src/app/core/achoo-tabs/ng-transclude.directive.ts.pre-build-optimizer.js